import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { KEY_ACCESS_TOKEN, X_API_KEY, KEY_REFRESH_TOKEN, REFRESH_URL, KEY_CONFIG_URL, KEY_AZURE_TOKEN } from '../Helpers/constant';
import { LoginData, VerifySignUpFormData } from '../interfaces/Auth';
import { EventFormValues, RegisterEvent } from '../interfaces/Events';
import { PaymentData } from '../interfaces/Common';
import { ApplyJob, FormPostJob, FormPostJobFavorite } from '../interfaces/Jobs';

let appConfig: { apiBaseUrl: string; tokenUrl: string } | undefined;
export let axiosInstance: AxiosInstance;
const configUrl = KEY_CONFIG_URL;

export const getAxiosInstance = (data: { config?: { apiBaseUrl: string; tokenUrl: string } }[]) => {
  appConfig = data[0]?.config;
  axiosInstance = axios.create({
    baseURL: appConfig?.apiBaseUrl,
    timeout: 15000,
  });

  axiosInstance.interceptors.request.use((req: AxiosRequestConfig): any => {
    const token = localStorage.getItem(KEY_AZURE_TOKEN);
    req.headers = req.headers || {};
    req.headers['x-api-key'] = X_API_KEY;
    req.headers['Authorization'] = `Bearer ${token}`;
    req.headers['access-token'] = localStorage.access_token;

    return req;
  });

  axiosInstance.interceptors.response.use(
    (resp) => {
      return resp;
    },
    async function (error) {
      if (!error.response?.config && error.response?.status !== 401) {
        return error;
      }
      return axios({
        method: 'get',
        baseURL: `${appConfig?.tokenUrl}`,
      }).then(async (response) => {
        if (localStorage.refresh_token && (error.response.status === 402 || error.response.status === 502 || error.response.status === 500)) {
          const url = REFRESH_URL;
          try {
            const res = await axios.post(
              url,
              {
                refreshToken: localStorage.refresh_token,
              },
              {
                headers: {
                  'access-token': localStorage.access_token,
                  Authorization: `Bearer ${localStorage.azure_token}`,
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                },
              }
            );
            localStorage.setItem(KEY_ACCESS_TOKEN, res?.data?.accessToken?.token);
            localStorage.setItem(KEY_REFRESH_TOKEN, res?.data?.refreshToken?.token);
            localStorage.setItem(KEY_AZURE_TOKEN, response.data.access_token);
            error.response.config.headers['Authorization'] = `Bearer ${response.data.access_token}`;
            error.response.config.headers['access-token'] = res.data.accessToken.token;
            return axios(error.response.config);
          } catch (err) {
            localStorage.clear();
            window.location.reload();
          }
        } else {
          localStorage.setItem(KEY_AZURE_TOKEN, response.data.access_token);
          error.response.config.headers['Authorization'] = `Bearer ${response.data.access_token}`;
          return axios(error.response.config);
        }
      });
    }
  );
};

export const getConfig = async () => {
  try {
    const path = 'dev-admission-portal.ken42.com';
    const res = await axios.get(`${configUrl}/${path}`);
    return res && res.data ? res.data : null;
  } catch (err) {
    return err;
  }
};

export const getOtp = async (email: string, reset: boolean) => {
  try {
    const path = `/v1/auth/academics/send/otp?email=${email}&update=${reset}`;
    const res = await axiosInstance.post(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const verifyOtp = async (data: VerifySignUpFormData) => {
  try {
    const path = `/v1/auth/academics/verify/otp`;
    const res = await axiosInstance.post(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const verifyOtpReset = async (email: string, otp: string) => {
  try {
    const path = `/v1/auth/academics/verify/otpwithContact?email=${email}&otp=${otp}`;
    const res = await axiosInstance.post(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const loginSSO = async (email: string) => {
  try {
    const path = `/v1/auth/sso/user/verify?email=${email}`;
    const response = axiosInstance.get(path);
    return response;
  } catch (error) {
    return error;
  }
};

export const authLogin = async (data: LoginData) => {
  const path = `/v1/academics/login`;
  const res: any = await axiosInstance.post(path, data);
  return res && res.data ? res.data : res;
};

export const bookedSlots = async (Id: any) => {
  const path = `/v1/academics/bookedSlots?facultyId=${Id}`;
  const res: any = await axiosInstance.get(path);
  return res && res.data ? res.data : res;
};

export const getCompletedInterview = async (Id: any) => {
  const path = `/v1/academics/completedInterview?facultyId=${Id}`;
  const res: any = await axiosInstance.get(path);
  return res && res.data ? res.data : res;
};

export const getApplication = async (Id: any) => {
  const path = `/v1/application/retrieve/application?applicationid=${Id}`;
  const res: any = await axiosInstance.get(path);
  return res && res.data ? res.data : res;
};

export const getForm = async (Id: any) => {
  const path = `/v1/application/retrieve/form?formid=${Id}`;
  const res: any = await axiosInstance.get(path);
  return res && res.data ? res.data : res;
};

export const getDocument = async (Id: any) => {
  const path = `/v1/application/retrieve/document?docid=${Id}`;
  const res: any = await axiosInstance.get(path);
  return res && res.data ? res.data : res;
};

export const getScoresheet = async (applicationId: any, round: any) => {
  const path = `/v1/academics/scoresheet?applicationId=${applicationId}&round=${round}`;
  const res: any = await axiosInstance.get(path);
  return res && res.data ? res.data : res;
};

export const postScoresheet = async (body: any) => {
  const path = `/v1/academics/scoresheet/save`;
  const res: any = await axiosInstance.post(path, body);
  return res && res.data ? res.data : res;
};
export const postAttendance = async (body: any) => {
  const path = `/v1/academics/attendance`;
  const res: any = await axiosInstance.post(path, body);
  return res && res.data ? res.data : res;
};

export const resetPassword = async (data: LoginData) => {
  try {
    const path = `/v1/academics/reset`;
    const res: any = await axiosInstance.post(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getEvents = async (contactId: string) => {
  try {
    const path = `/v1/event/fetch/user/events?accountId=${contactId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getEvent = async (id: string) => {
  try {
    const path = `/v1/event/fetch/event/ById?eventId=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getFileUrl = async (data: File) => {
  try {
    const path = `/v1/event/create/publicUrl`;
    const form = new FormData();
    form.append('file', data);
    const res: any = await axiosInstance.post(path, form);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const hostEvent = async (payload: EventFormValues) => {
  try {
    const path = `/v1/event/create/event/schedule`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const registerEvent = async (payload: RegisterEvent) => {
  try {
    const path = `/v1/event/new/registration`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const eventPayment = async (payload: PaymentData) => {
  try {
    const path = `/v1/payment/generate/payment`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const cancelEvent = async (id: string) => {
  try {
    const path = `/v1/event/cancel/registration?eventRegistrationId=${id}`;
    const res: any = await axiosInstance.delete(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getOptions = async (objectName: string, fieldName: string) => {
  try {
    const path = `/v1/helper/getDropDownValues?objectName=${objectName}&fieldName=${fieldName}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getAllJobs = async (conatctId: string) => {
  try {
    const path = `/v1/job/registred/job?contactId=${conatctId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getJob = async (jobId: string) => {
  try {
    const path = `/v1/job/individual/job?jobId=${jobId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const jobApply = async (payload: ApplyJob) => {
  try {
    const path = `/v1/job/apply/job`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postJob = async (payload: FormPostJob) => {
  try {
    const path = `/v1/job/post/job`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getFaq = async () => {
  try {
    const path = `/v1/support/get/faq`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getTicketHistory = async (accountId: string) => {
  try {
    const path = `/v1/support/get/user/case?userId=${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const cancelService = async (id: string) => {
  try {
    const path = `/v1/support/delete/case?caseId=${id}`;
    const res: any = await axiosInstance.delete(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getServices = async () => {
  try {
    const path = `/v1/support/get/service`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postJobFavorite = async (payload: FormPostJobFavorite) => {
  try {
    const path = `/v1/favourite/add/favorite`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getJobFavorite = async (accountId: string) => {
  try {
    const path = `/v1/favourite/get/user/favorite?accountId=${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
